import { render, staticRenderFns } from "./IndagineEpidemiologicaLegionellosiViewComponent.vue?vue&type=template&id=f9fdd008"
import script from "./IndagineEpidemiologicaLegionellosiViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaLegionellosiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports